import CurrencyItem from "@shared/Profile/CurrencyItem";

/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 03.07.25
 *
 */
export const Country = Object.freeze({
	US: 'US',
	UK: 'UK',
	NZ: 'NZ',
	CA: 'CA',
	AU: 'AU',
	EU: 'EU',
	IN: 'IN',
	JP: 'JP',
	CN: 'CN',
	BR: 'BR',
	ZA: 'ZA',
	RU: 'RU',
	MX: 'MX',
	KR: 'KR',
	AR: 'AR',
	DE: 'DE',
	FR: 'FR',
	IT: 'IT',
	ES: 'ES',
})

export const CountryName = Object.freeze({
	[Country.US]: 'United States',
	[Country.UK]: 'United Kingdom',
	[Country.NZ]: 'New Zealand',
	[Country.CA]: 'Canada',
	[Country.AU]: 'Australia',
	[Country.EU]: 'European Union',
	[Country.IN]: 'India',
	[Country.JP]: 'Japan',
	[Country.CN]: 'China',
	[Country.BR]: 'Brazil',
	[Country.ZA]: 'South Africa',
	[Country.RU]: 'Russia',
	[Country.MX]: 'Mexico',
	[Country.KR]: 'South Korea',
	[Country.AR]: 'Argentina',
	[Country.DE]: 'Germany',
	[Country.FR]: 'France',
	[Country.IT]: 'Italy',
	[Country.ES]: 'Spain'
})

export const CountryCurrencyCode = Object.freeze({
	[Country.US]: CurrencyItem.USD.currencyCode,
	[Country.UK]: CurrencyItem.GBP.currencyCode,
	[Country.NZ]: CurrencyItem.NZD.currencyCode,
	[Country.CA]: CurrencyItem.CAD.currencyCode,
	[Country.AU]: CurrencyItem.AUD.currencyCode,
	[Country.EU]: CurrencyItem.EUR.currencyCode,
	[Country.IN]: CurrencyItem.INR.currencyCode,
	[Country.JP]: CurrencyItem.JPY.currencyCode,
	[Country.CN]: CurrencyItem.CNY.currencyCode,
	[Country.BR]: CurrencyItem.BRL.currencyCode,
	// [Country.ZA]: CurrencyItem.ZAR.currencyCode,
	// [Country.RU]: CurrencyItem.RUB.currencyCode,
	// [Country.MX]: CurrencyItem.MXN.currencyCode,
	// [Country.KR]: CurrencyItem.KRW.currencyCode,
	// [Country.AR]: CurrencyItem.ARS.currencyCode,
	[Country.DE]: CurrencyItem.EUR.currencyCode,
	[Country.FR]: CurrencyItem.EUR.currencyCode,
	[Country.IT]: CurrencyItem.EUR.currencyCode,
	[Country.ES]: CurrencyItem.EUR.currencyCode,
})

//distance units

export const DistanceUnitFromCountry = Object.freeze({

	[Country.US]: 'mile',
	[Country.UK]: 'mile',
	[Country.NZ]: 'kilometer',
	[Country.CA]: 'kilometer',
	[Country.AU]: 'kilometer',
	[Country.EU]: 'kilometer',
	[Country.IN]: 'kilometer',
	[Country.JP]: 'kilometer',
	[Country.CN]: 'kilometer',
	[Country.BR]: 'kilometer',
	// [Country.ZA]: 'kilometer',
	// [Country.RU]: 'kilometer',
	// [Country.MX]: 'kilometer',
	// [Country.KR]: 'kilometer',
	// [Country.AR]: 'kilometer',
	[Country.DE]: 'kilometer',
	[Country.FR]: 'kilometer',
	[Country.IT]: 'kilometer',
	[Country.ES]: 'kilometer'


})


